import { createClient } from '@supabase/supabase-js';
import type { SupabaseClient } from '@supabase/supabase-js';

import { env } from '@/lib/env';
import { memorySessionStorage } from '@/lib/auth/storage';
import type { Database } from '@/types/database';

export const supabase: SupabaseClient<Database> = createClient<Database>(
  env.VITE_SUPABASE_URL,
  env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      // PKCE flow + custom storage = HIPAA-friendly. The custom storage
      // routes the session token to an in-memory Map (so it dies on
      // reload / close, never touching localStorage) while letting the
      // PKCE code_verifier reach sessionStorage so the OAuth round-trip
      // can complete. See src/lib/auth/storage.ts.
      persistSession: true,
      storage: memorySessionStorage,
      storageKey: 'careos-auth',
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
    },
    global: {
      headers: { 'x-client-info': 'careos-web' },
    },
  },
);
